export const isBlockOrInlineAttachment = (block: any) => (block.type === 'attachment' ? 'attachment' : 'block');
